import { Box, Grid, TextField } from "@mui/material";
import { squareToTsubo } from "common/functions/utilities";
import React, { useState } from "react";
import styles from "../PricingDialog.module.scss";

export const LandCalculate = React.memo(
  (props: {
    averageUnitPrice: number | undefined;
    tsuboArea: number | undefined;
    landAmount: number;
    onAveragePriceChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onTsuboAreaChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  }) => {
    const [squareArea, setSquareArea] = useState<number | undefined>(undefined);

    const onSquareAreaChange: (
      event: React.ChangeEvent<HTMLInputElement>
    ) => void = (event) => {
      const value = event.target.value;
      const newSquareArea = Number(value);

      if (isNaN(newSquareArea)) {
        setSquareArea(undefined);
        props.onTsuboAreaChange({
          ...event,
          target: {
            ...event.target,
            value: ""
          }
        });
        return;
      }

      setSquareArea(newSquareArea);
      props.onTsuboAreaChange({
        ...event,
        target: {
          ...event.target,
          value: value ? String(squareToTsubo(newSquareArea)) : ""
        }
      });
    };

    return (
      <Box className={styles.calculate}>
        <Box className={styles.category}>土地</Box>
        <Grid container columnSpacing={3} rowSpacing={2} className={styles.row}>
          <Grid
            className={styles.column}
            size={{
              sm: 12,
              md: "auto"
            }}
          >
            平均坪単価：
            <TextField
              className={styles.averagePriceInput}
              value={props.averageUnitPrice || ""}
              type="number"
              slotProps={{
                input: {
                  classes: { notchedOutline: styles.noBorder }
                }
              }}
              onChange={props.onAveragePriceChange}
            />
            万円
          </Grid>
          <Grid
            className={`${styles.column} ${styles.operator}`}
            size={{
              sm: 12,
              md: "auto"
            }}
          >
            ×
          </Grid>
          <Grid
            className={styles.column}
            size={{
              sm: 12,
              md: "grow"
            }}
          >
            面積：
            <TextField
              className={styles.squareAreaInput}
              value={squareArea || ""}
              type="number"
              slotProps={{
                input: {
                  classes: { notchedOutline: styles.noBorder }
                }
              }}
              onChange={onSquareAreaChange}
            />
            ㎡ （<Box className={styles.tsuboArea}>{props.tsuboArea || 0}</Box>{" "}
            坪）
          </Grid>
          <Grid
            className={`${styles.column} ${styles.operator}`}
            size={{
              sm: 12,
              md: "auto"
            }}
          >
            =
          </Grid>
          <Grid
            className={`${styles.column}`}
            size={{
              sm: 12,
              md: "auto"
            }}
          >
            <span className={styles.amount}>{props.landAmount}</span>
            万円
          </Grid>
        </Grid>
      </Box>
    );
  }
);
